/**
 * useOnboarding - New user onboarding flow state
 * Extracted from App.js Phase 5 refactoring
 */
import { useState } from 'react';

const useOnboarding = () => {
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [onboardingStep, setOnboardingStep] = useState(1);
  const [onboardingData, setOnboardingData] = useState({
    // Step 1: Goal
    goal: '',
    // Step 2: Basic Profile
    age: '',
    gender: '',
    height: '',
    weight: '',
    activityLevel: 'moderate',
    // Imperial support
    useImperial: false,
    heightFt: '',
    heightIn: '',
    weightLbs: '',
    // Optional: Goal weight
    goalWeight: '',
    goalWeightLbs: ''
  });

  const resetOnboarding = () => {
    setOnboardingStep(1);
    setOnboardingData({
      goal: '',
      age: '',
      gender: '',
      height: '',
      weight: '',
      activityLevel: 'moderate',
      useImperial: false,
      heightFt: '',
      heightIn: '',
      weightLbs: '',
      goalWeight: '',
      goalWeightLbs: ''
    });
  };

  return {
    showOnboarding, setShowOnboarding,
    onboardingStep, setOnboardingStep,
    onboardingData, setOnboardingData,
    resetOnboarding
  };
};

export default useOnboarding;
